import { TYPES } from "../actions/importAction";

const {
  API_REQUEST,
  API_ERROR,
  API_SUCCESS,
  CLEAR_ERROR,

  GET_FOLDER_STRUCUTRE_SUCCESS,
  CREATE_PRESENTATION_SUCCESS,
  GET_PRESENTATION_LIST_SUCCESS,
  SHARE_PRESENTATION_SUCCESS,
  UPDATE_PRESENTATION_SUCCESS,
  LIST_KEYMESSAGE_SUCCESS,
  CREATE_KEYMESSAGE_SUCCESS,
  UPDATE_KEYMESSAGE_SUCCESS,
  GET_KEYMESSAGE_LIST_SUCCESS,
  GET_FOLDER_STRUCTURE_SUCCESS,
  UPDATE_BULK_KEYMESSAGE_SUCCESS,

  DELETE_PRESENTATION,
  DELETE_KEYMESSAGE,

  USER_LIST,
} = TYPES;

const initialState = {
  loading: false,
  presentations: [],
  keyMessages: [],
  structures: [],
  users: [],
  keyMessageList: [],
  folderStructure: null,
  error: false,
  msg: null,
};

const importReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ERROR:
      return {
        ...state,
        error: false,
        loading: false,
        msg: null,
      };

    case GET_FOLDER_STRUCUTRE_SUCCESS:
      return {
        ...state,
        structures: action.data,
        loading: false,
      };
    case CREATE_PRESENTATION_SUCCESS:
      return {
        ...state,
        presentations: [action.data, ...state.presentations],
        loading: false,
        msg: "Presentation created successfully",
      };

    case GET_PRESENTATION_LIST_SUCCESS:
      return {
        ...state,
        presentations: action.data,
        loading: false,
      };

    case SHARE_PRESENTATION_SUCCESS:
      const allPresn = [...state.presentations];
      const newPresn = allPresn.map((p) =>
        p._id === action.data.pId
          ? { ...p, sharedWith: action.data.sharedWithData }
          : p
      );
      return {
        ...state,
        presentations: newPresn,
        loading: false,
        msg: "Share Presenation is updated successfully!!",
      };

    case UPDATE_PRESENTATION_SUCCESS:
      const allPres = [...state.presentations];
      const newPres = allPres.map((p) =>
        p._id === action.data.pId ? { ...p, name: action.data.name } : p
      );
      return {
        ...state,
        presentations: newPres,
        msg: "Presentation Name Updated Successfully",
      };

    case LIST_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: action.data,
        loading: false,
      };

    case CREATE_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: [...state.keyMessages, action.data],
        loading: false,
        msg: "KeyMessage Created Successfully",
      };

    case UPDATE_BULK_KEYMESSAGE_SUCCESS:
      return {
        ...state,
        keyMessages: action.data,
        msg: "Bulk update completed.",
        error: false,
      };

    case DELETE_PRESENTATION:
      let presentations = [...state.presentations];

      return {
        ...state,
        presentations: presentations.filter((p) => p._id !== action.data),
        loading: false,
        msg: "Presentation deleted successfully",
      };

    case DELETE_KEYMESSAGE:
      let keyMessages = [...state.keyMessages];

      return {
        ...state,
        keyMessages: keyMessages.filter((p) => {
          return (
            p._id !== action.data.kmId || p.presentation !== action.data.pId
          );
        }),
        loading: false,
        error: false,
        msg: "Key message deleted successfully",
      };

    case UPDATE_KEYMESSAGE_SUCCESS:
      const allKMs = [...state.keyMessages];
      const newKMs = allKMs.map((km) =>
        km._id === action.data.kmId && km.presentation === action.data.pId
          ? { ...km, name: action.data.name }
          : km
      );

      return {
        ...state,
        keyMessages: newKMs,
        loading: false,
        error: false,
        msg: "Key message updated successfully",
      };

    case GET_KEYMESSAGE_LIST_SUCCESS:
      return {
        ...state,
        keyMessageList: action.data,
        loading: false,
      };

    case GET_FOLDER_STRUCTURE_SUCCESS:
      return {
        ...state,
        folderStructure: action.data,
        loading: false,
      };

    case API_REQUEST:
      return { ...state, loading: true };

    case API_ERROR:
      return {
        ...state,
        presentationError: action.data,
        loading: false,
        error: true,
        msg: action.data,
      };

    case API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        msg: action.data || "Success",
      };

    case USER_LIST:
      return {
        ...state,
        loading: false,
        users: action.data,
      };

    default:
      return state;
  }
};

export default importReducer;
